import React from "react";
import { Paper } from "@mui/material";

import Gallery from "./gallery";

const CampusHighlights = () => {
  return (
    <>
      <div>
        <Paper elevation={3}>
          <div className="m-2">
            <div className="text-center">
              <h2 className="m-3 p-3 pt-5"> CAMPUS HIGHLIGHTS </h2>
            </div>

            <div className="row">
              <div className="col-md-8">
                <Gallery />
              </div>
              <div className="col-md-4">
                <iframe
                  width="100%"
                  height="315"
                  src="https://www.youtube.com/embed/N0MOkGI1uEQ?si=-AnFDHcpuv_-Xha3"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowfullscreen
                ></iframe>
                {/* <iframe width="100%" height="315" src="https://www.youtube.com/embed/V741wtomyk8" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe> */}
                <div className="col-md-12">
                  <img
                    src="/assets/campus/15.jpg"
                    className="img-fluid"
                    alt="pews campus img"
                  />
                </div>
              </div>

              {/* <div className="col-md-3">
                                <img src="/assets/campus/img4.jpg" className='img-fluid' alt="img" />
                            </div> */}
            </div>
          </div>
        </Paper>
      </div>
    </>
  );
};

export default CampusHighlights;
